import { stats } from '@fiverr-private/obs';
import { genericCount } from './generic';

export const count = genericCount(stats);
